import { ButtonHeading, CommonDateRange, CustomPagination, CustomSelect } from 'components'
import { AddFundCanvas, ConfirmModalFor, PaymentVoucher } from 'modals'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { LuWallet } from 'react-icons/lu'
import './payNowTransaction.css'
import { useLocation, useNavigate } from 'react-router-dom'
import StorageService from 'utils/StorageServices'
import { deleteTransactionApi, getPaynowAccountingTransaction } from '_services'
import toast from 'react-hot-toast'
import { utils } from 'helper'
import AccountStatementModal from './AccountStatementModal'
import FilePreparationModal from './FilePreparationModal'
import ConsolidatedStatementModal from './ConsolidatedStatementModal'
import printHtmlContent from 'helper/utils'
import { getVoucherReport } from '_services/accountingServices/accountingServices'
import { Images } from "constants";


const PayNowTransaction = () => {

    const [activeTab, setActiveTab] = useState(1);
    const [openEditModal, setOpenEditModal] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    let isToken = localStorage.getItem("token");
    const { data } = location.state || {};
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [showAddFund, setShowAddFund] = useState(false);
    const [transactionList, setTransactionList] = useState([]);
    const isFirstRun = useRef(true);
    const [isSearch, setIsSearch] = useState('')
    const [totalItems, setTotalItems] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const tableContainerRef = useRef(null);
    const isFetchingRef = useRef(false);
    const currentOffsetRef = useRef(1);
    const [filter, setFilter] = useState({
        limit: 20,
        offset: 1,
        search: '',
    });
    const [selectedRange, setSelectedRange] = useState({
        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),
    });

    const [accountDetails, setAccountDetails] = useState({})
    const [accountStatementOpen, setAccountStatementOpen] = useState(false);
    const [filePreparationOpen, setFilePreparationOpen] = useState(false);
    const [isconsolidatedStatement, setIsconsolidatedStatement] = useState(false)
    const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);
    const [confirmModalShow, setConfirmModalShow] = useState(false);
    const [paymentData, setPaymentData] = useState({
        voucher_id: "",
        data: {}
    })

    const [printLoadingId, setPrintLoadingId] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false)

    const getAccountTransactionListHandler = async (dataParam, isReset = false, isLoadMore = false, customOffset = null) => {
        if (!dataParam || isFetchingRef.current) {
            console.error(dataParam);
            return;
        }

        try {
            isFetchingRef.current = true;

            if (isLoadMore) {
                setLoadingMore(true);
            } else {
                setLoading(true);
            }

            const offsetToUse = customOffset !== null ? customOffset : (isLoadMore ? currentOffsetRef.current : 1);


            const res = await getPaynowAccountingTransaction({
                limit: filter.limit,
                offset: offsetToUse,
                search: filter.search,
                company_id: StorageService?.getCompanyId(),
                account_id: dataParam?.account_id,
                start_date: moment(selectedRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(selectedRange.endDate).format("YYYY-MM-DD"),
                approval_status: activeTab,
            });

            if (res?.responseCode === 200) {
                const { list, ...resData } = res?.data;

                let newList = list || [];
                const actualReturnedCount = newList.length;

                // Handle N+1 pagination (API returns 21 when limit is 20)
                let moreDataExists = false;
                if (actualReturnedCount > filter.limit) {
                    // API returned more than limit (e.g., 21 when limit is 20)
                    moreDataExists = true;
                    // Keep only limit items, we'll fetch the extra item in next call
                    newList = newList.slice(0, filter.limit);
                } else if (actualReturnedCount === filter.limit) {
                    // Returned exactly the limit, might have more
                    moreDataExists = true;
                } else {
                    // Returned less than limit, no more data
                    moreDataExists = false;
                }

                // For offset > 1, skip the first item (it's duplicate from previous page)
                if (offsetToUse > 1 && newList.length > 0) {

                    newList = newList.slice(1);
                }

                // Special filtering for activeTab == 2 on first load
                if (activeTab == 2 && newList.length > 0 && offsetToUse === 1) {

                    newList = newList.filter((_, index) => index !== 0);
                }


                // Update hasMore state
                setHasMore(moreDataExists);

                if (isReset || !isLoadMore) {
                    // First load - set everything including balances
                    setAccountDetails(res?.data?.account_detail);
                    setTotalItems(res?.data?.total_record);
                    setTransactionList({
                        ...res?.data,
                        list: newList
                    });

                } else {
                    // Append mode - keep previous balances, only add new list items
                    setTransactionList(prev => {
                        const updatedList = [...(prev?.list || []), ...newList];

                        return {
                            ...prev, // Keep all previous data (balances, etc.)
                            list: updatedList
                        };
                    });
                }

            } else {

                navigate('/accounting/transactions');
            }
        } catch (error) {

            toast.error('Error');
        } finally {
            isFetchingRef.current = false;
            if (isLoadMore) {
                setLoadingMore(false);
            } else {
                setLoading(false);
            }
        }
    };

    // Infinite scroll handler
    const handleScroll = () => {
        if (!tableContainerRef.current || loadingMore || !hasMore || isFetchingRef.current) return;

        const { scrollTop, scrollHeight, clientHeight } = tableContainerRef.current;

        // Check if user has scrolled to bottom (with 100px threshold)
        if (scrollTop + clientHeight >= scrollHeight - 100) {
            // Increment offset
            currentOffsetRef.current = currentOffsetRef.current + 1;
            // Update state
            setFilter((prev) => ({ ...prev, offset: currentOffsetRef.current }));

            // Call API with new offset
            getAccountTransactionListHandler(data, false, true, currentOffsetRef.current);
        }
    };

    const handleApply = (newRange) => {
        setSelectedRange(newRange);

    };


    // Add scroll event listener
    useEffect(() => {
        const container = tableContainerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
            return () => container.removeEventListener('scroll', handleScroll);
        }
    }, [loadingMore, hasMore, transactionList]);

    useEffect(() => {
        setTransactionList([]);
        setFilter((s) => ({ ...s, offset: 1 }));
        currentOffsetRef.current = 1;
        setHasMore(true);
        isFetchingRef.current = false;
        getAccountTransactionListHandler(data, true);
    }, [selectedRange, activeTab, filter.search]);

    const getCategoriesNames = (item) => {
        if (item?.voucher_id?.category_type === 1) {
            return (
                <>
                    <p>{item?.voucher_id?.categories?.[0]?.category?.name || "-"}</p>

                    <div style={{ fontSize: "11.2px" }}>
                        {item?.trip?.route_name && (
                            <p className="pas_decs">{item.trip.route_name}</p>
                        )}

                        {item?.tags?.vehicle?.vehicle_no && (
                            <p className="pas_decs">
                                Vehicle No - {item.tags.vehicle.vehicle_no}
                            </p>
                        )}
                    </div>
                </>
            );
        }

        if (item?.voucher_id?.category_type === 2) {
            return item?.voucher_id?.category_name || "-";
        }

        // fallback if nothing matches
        return "-";
    };


    const handleDownloadStatement = () => {
        setAccountStatementOpen(false);
        onStatementHistory()
    };

    const onStatementHistory = () => {
        navigate('/paynow-downloads');
    }

    const handlePrintDownload = async (voucherId) => {
        try {
            setPrintLoadingId(voucherId);

            const res = await getVoucherReport({
                company_id: StorageService?.getCompanyId(),
                voucher_id: voucherId,
            });

            printHtmlContent({
                html: res,
                title: `Bilty-${voucherId}`,
                onAfter: () => setPrintLoadingId(false),
            });

        } catch (err) {
            console.error('Print error:', err);
            setPrintLoadingId(false);
        }
    };

    const handleDelete = async () => {

        const payload = {
            company_id: StorageService?.getCompanyId(),
            transaction_id: confirmModalShow?._id || paymentVoucherOpen?._id
        }
        try {
            setDeleteLoading(true)
            const res = await deleteTransactionApi(payload)
            if (res?.responseCode == 200) {
                toast.success(res?.responseMessage)
                setConfirmModalShow(false);
                setPaymentVoucherOpen(false)
                setDeleteLoading(false)
                getAccountTransactionListHandler(data, true);

            } else {
                setDeleteLoading(false)
                // toast.error(res?.responseMessage)
            }
        } catch (error) {
            setDeleteLoading(false)
            toast.error(error?.message)
        }
    };


    const accountStatementProps = {

        isOpen: accountStatementOpen,
        closeModal: () => setAccountStatementOpen(false),
        modalMainClass: "_dashCommon_Modal _smModal addbalance",
        modalTitle: "Quick Statement",
        onDownload: handleDownloadStatement,
        accountDetails: accountDetails
    };

    const filePreparationProps = {
        isOpen: filePreparationOpen,
        closeModal: () => setFilePreparationOpen(false),
        modalMainClass: "_dashCommon_Modal _smModal addbalance",
        modalTitle: "Statement",
        submitTitle: "Okay, got it!",
        title: 'Your File is Being Prepared',
        message: "This may take a few minutes. We'll notify you via email once your file is ready.",
        onStatementHistory: onStatementHistory,
        headerPart: false
    };

    const consolidateProps = {
        isOpen: isconsolidatedStatement,
        closeModal: () => setIsconsolidatedStatement(false),
        modalMainClass: "_dashCommon_Modal _smModal addbalance",
        modalTitle: "Consolidated Statement",

    };

    const paymentVoucherProps = {
        paymentVoucherOpen: paymentVoucherOpen,
        closeModal: () => setPaymentVoucherOpen(false),
        voucherId: paymentVoucherOpen?.voucher_id?._id,
        oprnDeleteModal: setConfirmModalShow,
        onPrintHandle: handlePrintDownload,
        printLoadingId
    }

    let confirmModalProps = {
        show: confirmModalShow,
        closeModal: (e) => {
            setConfirmModalShow(false);
        },
        title: "Confirm",
        submitTitle: "Delete",
        onSubmit: handleDelete,
        confirmModal: "confirmModal",
        icon: Images.DELETEICON.default,
        isLoadding: deleteLoading,
        disabled: deleteLoading
    };

    return (
        <>
            <ButtonHeading title={transactionList?.account_detail?.name} />

            <div className='__payNw_mainBx'>
                <div className='__pyAll_filts'>

                    <div className='__pyFirst_flts'>
                        <div className='__pyBal_row'>
                            <div className='__payWal_icon'><LuWallet /></div>

                            <div className='__payWal_row'>
                                <div className='__payAll_bal_bx'>
                                    <div className='__pyAc_head'>Account Balance</div>
                                    <p className='__pyAcc_bal'>
                                        ₹ {Number(transactionList?.available_balance ?? 0).toFixed(2)}
                                    </p>
                                </div>

                                <div className='__payAll_bal_bx'>
                                    <div className='__pyAc_head'>Under Process</div>
                                    <p className='__pyUnPro_bal'>
                                        ₹ {Number(transactionList?.account_detail?.under_approval_balance ?? 0).toFixed(2)}
                                    </p>
                                </div>

                                <div className='__payAll_bal_bx'>
                                    <div className='__pyAc_head'>Failed</div>
                                    <p className='__pyFail_bal'>
                                        ₹ {Number(transactionList?.account_detail?.under_approval_balance ?? 0).toFixed(2)}
                                    </p>
                                </div>
                            </div>

                            <div className="__pyBal_actions">
                                <button className="anime-btn __btn_addFunds" onClick={() => setShowAddFund(true)}>Add Funds</button>
                                {/* <button className="anime-btn __btn_statement" onClick={() => setAccountStatementOpen(true)}>Statement</button> */}
                                <div class="dropdown">
                                    <button
                                        class=" anime-btn __btn_statement"
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        Statement
                                    </button>
                                    <ul class="dropdown-menu ">
                                        {/* {userSettingPermission?.expenses_approval === 1 && ( */}
                                        <li>
                                            <a
                                                class="dropdown-item px-2"
                                                onClick={() => setAccountStatementOpen(true)}
                                            >
                                                Quick Statement
                                            </a>
                                        </li>
                                        {/* )} */}
                                        <li>
                                            {/* old code = title: receipt */}
                                            <a
                                                class="dropdown-item px-2"
                                                onClick={() => setIsconsolidatedStatement(true)}
                                            >
                                                Consolidated
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='__seletionFlx_bx'>
                        <div className='__selcField_bx'>
                            <CustomSelect
                                placeholder={`Category`}
                                label={`Category`}
                                options={[]}
                            />
                        </div>

                        <div className='__selcField_bx'>
                            <CommonDateRange
                                key={`${selectedRange.startDate}-${selectedRange.endDate}`}
                                initialStartDate={selectedRange.startDate}
                                initialEndDate={selectedRange.endDate}
                                onApply={handleApply}
                            />
                        </div>

                        <div className='__selcField_bx'>
                            <CustomSelect
                                placeholder={`Status`}
                                label={`Status`}
                                options={[]}
                            />
                        </div>

                        <div className='__selcField_bx'>
                            <div className='_inpW_search _lrl_inpSrch '>
                                <svg
                                    className="srcIcon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                >
                                    <path
                                        opacity="0.2"
                                        d="M17.347 16.3507L12.7293 11.733C13.8389 10.4008 14.3923 8.69214 14.2742 6.96238C14.1562 5.23263 13.3757 3.61498 12.0954 2.44596C10.815 1.27695 9.13319 0.64656 7.39985 0.685944C5.66652 0.725329 4.0151 1.43145 2.78913 2.65742C1.56317 3.88339 0.857043 5.53481 0.817658 7.26814C0.778274 9.00147 1.40866 10.6833 2.57768 11.9636C3.7467 13.244 5.36434 14.0244 7.0941 14.1425C8.82385 14.2606 10.5325 13.7072 11.8647 12.5976L16.4824 17.2153L17.347 16.3507ZM2.06069 7.43204C2.06069 6.34363 2.38344 5.27967 2.98812 4.3747C3.5928 3.46972 4.45227 2.76438 5.45782 2.34787C6.46337 1.93135 7.56985 1.82238 8.63734 2.03471C9.70483 2.24705 10.6854 2.77117 11.455 3.54078C12.2246 4.3104 12.7487 5.29095 12.9611 6.35844C13.1734 7.42593 13.0644 8.53241 12.6479 9.53797C12.2314 10.5435 11.5261 11.403 10.6211 12.0077C9.71611 12.6124 8.65215 12.9351 7.56375 12.9351C6.10474 12.9335 4.70596 12.3532 3.67428 11.3215C2.64261 10.2898 2.0623 8.89104 2.06069 7.43204Z"
                                        fill="black"
                                    ></path>
                                </svg>
                                <input
                                    type="text"
                                    className='simpleFilter_input'
                                    placeholder='Search'
                                // value={filter.search}
                                // onChange={(e) => setFilter((s) => ({ ...s, search: e.target.value }))}
                                />
                            </div>
                        </div>

                        <button className='anime-btn __btn_resetFilter'>Reset Filter</button>
                    </div>

                </div>

                <div
                    className='pas_tableMain'
                    ref={tableContainerRef}
                    style={{
                        maxHeight: '600px',
                        overflowY: 'auto',
                        position: 'relative'
                    }}
                >
                    <table className="pas_table">
                        <thead>
                            <tr>
                                <th>Date & Time</th>

                                <th>Voucher</th>
                                <th>Reference</th>
                                <th>Category</th>
                                <th>Mode</th>
                                <th>To Account</th>
                                <th style={{ textAlign: "left" }}>Status</th>
                                <th style={{ textAlign: "center" }}>Cr./Dr.</th>
                                <th>Amount</th>
                                {/* <th>Balance</th> */}
                            </tr>
                        </thead>

                        <tbody>
                            {transactionList?.list?.map((i, index) => <tr style={{ cursor: "pointer" }} key={`${i?.transaction_no}-${index}`} onClick={() => setPaymentVoucherOpen(i)}>
                                <td>
                                    <p>{i?.date ? utils.formatDateMonth(i?.date) : "-"}</p>
                                    <span>{i?.date ? utils.formatTimeWithoutConvertnew(i?.date) : "-"}</span>
                                </td>



                                <td>
                                    <span>{i?.voucher_no || "-"}</span>
                                </td>
                                <td><span>{i?.eb_transaction_reference || "-"}</span></td>
                                <td>
                                    {getCategoriesNames(i)}

                                </td>

                                <td>
                                    {i?.eb_payment_mode || "-"}

                                </td>

                                <td>
                                    <p className="pas_decs">{i?.entries?.account?.name}</p>

                                    {i?.vendor_bank_account?.account_name ? <div style={{ fontSize: '11.2px' }}>
                                        <p className="pas_decs">{`A/C Number: ${i?.vendor_bank_account?.account_number || ""}`}</p>
                                        <p className="pas_decs">{`IFSC: ${i?.vendor_bank_account?.ifsc_code || ""}`}</p>
                                        <p className="pas_decs">{`Bank: ${i?.vendor_bank_account?.bank_name || ""}`}</p>
                                        <p className="pas_decs">{`Holder :${i?.vendor_bank_account?.account_name || ""}`}</p>
                                    </div> : "-"}
                                </td>

                                <td>
                                    {/* <div className="__pas_success_bx">Success</div>
                                    <p style={{ fontSize: '11.2px' }}>14 Jan 26 | 03:19 PM</p> */}

                                    <div className={`__pas_${i?.approval_status === 5 ? 'success' : i?.approval_status === 9 || i?.approval_status === 4 ? 'failed' : 'pending'}_bx`}>
                                        {i?.approval_status === 5 ? 'Success' : i?.approval_status === 9 || i?.approval_status === 4 ? 'Failed' : !i?.approval_status ? "" : 'Pending'}
                                    </div>
                                    {i?.completed_date && (
                                        <p style={{ fontSize: '11.2px' }}>
                                            {utils.formatDateMonth(i?.completed_date)} | {utils.formatTime(i?.completed_date)}
                                        </p>
                                    )}
                                </td>

                                <td>
                                    <div className={`__pas_${i?.entries?.credit_amount ? 'cr' : 'dr'}_bx`}>
                                        {/* <div className={`__pas_cr_bx`}> */}

                                        {i?.entries?.credit_amount ? 'CR' : 'DR'}


                                    </div>
                                </td>

                                <td>
                                    <p className={`__pas_${i?.entries?.credit_amount ? 'cr' : 'dr'}_txt`}>
                                        {/* <p className={`__pas_cr_txt`}> */}

                                        ₹ {Number(i?.total_amount || 0).toFixed(2)}
                                    </p>
                                </td>

                                {/* <td>
                                    <p>₹ {Number(i?.balance || 0).toFixed(2)}</p>
                                </td> */}
                            </tr>)}

                            {loadingMore && (
                                <tr>
                                    <td colSpan="10" style={{ textAlign: 'center', padding: '20px' }}>
                                        <div>Loading more...</div>
                                    </td>
                                </tr>
                            )}

                            {!hasMore && transactionList?.list?.length > 0 && (
                                <tr>
                                    <td colSpan="10" style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                                        <div>No more transactions to load</div>
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>
            </div>



            <div
                className={`offcanvas offcanvas-end common_offCanvas payConfirmCanvas ${showAddFund ? "show" : ""
                    }`}
                tabIndex={-1}
                style={{ visibility: showAddFund ? "visible" : "hidden" }}
            >
                {showAddFund && (
                    <>
                        <AddFundCanvas
                            isOpen={showAddFund}
                            closeModal={() => setShowAddFund(false)}
                            accountDetails={accountDetails}
                        />
                    </>
                )}
            </div>

            <div className={showAddFund ? "offBack_drop" : ""}></div>

            {accountStatementOpen && <AccountStatementModal {...accountStatementProps} />}
            {filePreparationOpen && <FilePreparationModal {...filePreparationProps} />}
            {isconsolidatedStatement && <ConsolidatedStatementModal {...consolidateProps} />}
            {paymentVoucherOpen && <PaymentVoucher {...paymentVoucherProps} />}
            {confirmModalShow && (
                <ConfirmModalFor {...confirmModalProps}>
                    <>
                        <p className="_confirmPrx">
                            {" "}
                            Are you sure you want to delete " {"Transaction"} "{" "}
                        </p>
                    </>
                </ConfirmModalFor>
            )}

        </>
    )
}

export default PayNowTransaction